import GatedPaymentsModule from './GatedPaymentsModule';

export default GatedPaymentsModule;
